module.exports = __webpack_public_path__ + "img/step2.c875c969.png";